export const breadcrumb = {
  dashboard: 'Dashboard',
  profile: 'Profil',
  logout: 'Keluar',
  document: {
    index: 'Dokumen',
    create: 'Tambah dokumen'
  },
  payment: {
    index: 'Pembayaran'
  },
  price: {
    index: 'Harga'
  }
};
